// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"20194f8b","115":"913e4881","120":"119e89b2","198":"2d90bd9a","270":"e8dc67c0","435":"a433ac15","522":"0496a2f7","729":"72019922","762":"a7b6b731","766":"0b77a019","794":"71208545","825":"5dd5215f"}[chunkId] + ".chunk.js";
};